(function () {

var $5b55226219c5badd$exports = {};
$5b55226219c5badd$exports = React;


const $5e62cac5aac90bdd$var$KirkiInputSliderForm = (props)=>{
    const { control: control, customizerSetting: customizerSetting, choices: choices } = props;
    let trigger = "";
    const validateValue = (value)=>{
        if ('' != value) {
            if (value < choices.min) value = choices.min;
            if (value > choices.max) value = choices.max;
        }
        return value;
    };
    const getValueObject = (value)=>{
        value = "string" !== typeof value ? value.toString() : value;
        const valueUnit = value.replace(/\d+/g, "");
        let valueNumber = value.replace(valueUnit, "");
        valueNumber = '' != valueNumber ? parseFloat(valueNumber.trim()) : '';
        valueNumber = validateValue(valueNumber);
        return {
            number: valueNumber,
            unit: valueUnit
        };
    };
    const getValueForInput = (value)=>{
        const valueObject = getValueObject(value);
        return valueObject.number + valueObject.unit;
    };
    const getValueForSlider = (value)=>{
        return getValueObject(value).number;
    };
    control.updateComponentState = (val)=>{
        if ("slider" === trigger) valueRef.current.value = getValueForInput(val);
        else if ("input" === trigger) sliderRef.current.value = getValueForSlider(val);
        else if ("reset" === trigger) {
            valueRef.current.value = val;
            sliderRef.current.value = val;
        }
    };
    const handleInputChange = (e)=>{
        trigger = "input";
        customizerSetting.set(getValueForInput(e.target.value));
    };
    const handleSliderChange = (e)=>{
        trigger = "slider";
        let value = parseFloat(e.target.value);
        value = validateValue(value);
        const inputValueObj = getValueObject(valueRef.current.value); // We're going to use the unit.
        const valueForInput = value + inputValueObj.unit;
        customizerSetting.set(valueForInput);
    };
    const handleReset = (e)=>{
        if ("" !== props.default && "undefined" !== typeof props.default) {
            sliderRef.current.value = props.default;
            valueRef.current.value = props.default;
        } else if ("" !== props.value) {
            sliderRef.current.value = props.value;
            valueRef.current.value = props.value;
        } else {
            sliderRef.current.value = choices.min;
            valueRef.current.value = "";
        }
        trigger = "reset";
        customizerSetting.set(sliderRef.current.value);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
            e.preventDefault();
            const currentValue = getValueForSlider(valueRef.current.value);
            const step = choices.step || 1;
            let newValue = currentValue;
            if (e.key === 'ArrowUp') newValue = currentValue + step;
            else if (e.key === 'ArrowDown') newValue = currentValue - step;
            newValue = validateValue(newValue);
            const inputValueObj = getValueObject(valueRef.current.value);
            const valueForInput = newValue + inputValueObj.unit;
            // Update both input and slider values
            valueRef.current.value = valueForInput;
            sliderRef.current.value = newValue;
            trigger = 'input';
            customizerSetting.set(valueForInput);
        }
    };
    // Preparing for the template.
    const fieldId = `kirki-control-input-${customizerSetting.id}`;
    const sliderValue = getValueForSlider(props.value);
    const inputValue = getValueForInput(props.value);
    const sliderRef = (0, $5b55226219c5badd$exports.useRef)(null);
    const valueRef = (0, $5b55226219c5badd$exports.useRef)(null);
    return /*#__PURE__*/ React.createElement("div", {
        className: "kirki-control-form",
        tabIndex: "1"
    }, /*#__PURE__*/ React.createElement("label", {
        className: "kirki-control-label",
        htmlFor: fieldId
    }, /*#__PURE__*/ React.createElement("span", {
        className: "customize-control-title"
    }, props.label), /*#__PURE__*/ React.createElement("span", {
        className: "customize-control-description description",
        dangerouslySetInnerHTML: {
            __html: props.description
        }
    })), /*#__PURE__*/ React.createElement("div", {
        className: "customize-control-notifications-container",
        ref: props.setNotificationContainer
    }), /*#__PURE__*/ React.createElement("button", {
        type: "button",
        className: "kirki-control-reset",
        onClick: handleReset
    }, /*#__PURE__*/ React.createElement("i", {
        className: "dashicons dashicons-image-rotate"
    })), /*#__PURE__*/ React.createElement("div", {
        className: "kirki-control-cols"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "kirki-control-left-col"
    }, /*#__PURE__*/ React.createElement("input", {
        ref: sliderRef,
        type: "range",
        id: fieldId,
        defaultValue: sliderValue,
        min: choices.min,
        max: choices.max,
        step: choices.step,
        className: "kirki-control-input-slider kirki-pro-control-input-slider",
        onChange: handleSliderChange
    })), /*#__PURE__*/ React.createElement("div", {
        className: "kirki-control-right-col"
    }, /*#__PURE__*/ React.createElement("input", {
        ref: valueRef,
        type: "text",
        defaultValue: inputValue,
        className: "kirki-control-input",
        onChange: handleInputChange,
        onKeyDown: handleKeyDown
    }))));
};
var $5e62cac5aac90bdd$export$2e2bcd8739ae039 = $5e62cac5aac90bdd$var$KirkiInputSliderForm;


function $a8a3b6d68a8446d2$var$_extends() {
    return $a8a3b6d68a8446d2$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $a8a3b6d68a8446d2$var$_extends.apply(null, arguments);
}
/**
 * KirkiInputSliderControl.
 *
 * Global objects brought:
 * - wp
 * - jQuery
 * - React
 * - ReactDOM
 *
 * @class
 * @augments wp.customize.Control
 * @augments wp.customize.Class
 */ const $a8a3b6d68a8446d2$var$KirkiInputSliderControl = wp.customize.Control.extend({
    /**
   * Initialize.
   *
   * @param {string} id - Control ID.
   * @param {object} params - Control params.
   */ initialize: function(id, params) {
        const control = this;
        // Bind functions to this control context for passing as React props.
        control.setNotificationContainer = control.setNotificationContainer.bind(control);
        wp.customize.Control.prototype.initialize.call(control, id, params);
        // The following should be eliminated with <https://core.trac.wordpress.org/ticket/31334>.
        function onRemoved(removedControl) {
            if (control === removedControl) {
                control.destroy();
                control.container.remove();
                wp.customize.control.unbind("removed", onRemoved);
            }
        }
        wp.customize.control.bind("removed", onRemoved);
    },
    /**
   * Set notification container and render.
   *
   * This is called when the React component is mounted.
   *
   * @param {Element} element - Notification container.
   * @returns {void}
   */ setNotificationContainer: function setNotificationContainer(element) {
        const control = this;
        control.notifications.container = jQuery(element);
        control.notifications.render();
    },
    /**
   * Render the control into the DOM.
   *
   * This is called from the Control#embed() method in the parent class.
   *
   * @returns {void}
   */ renderContent: function renderContent() {
        const control = this;
        ReactDOM.render(/*#__PURE__*/ React.createElement((0, $5e62cac5aac90bdd$export$2e2bcd8739ae039), $a8a3b6d68a8446d2$var$_extends({}, control.params, {
            control: control,
            customizerSetting: control.setting,
            setNotificationContainer: control.setNotificationCotainer,
            value: control.params.value
        })), control.container[0]);
        if (false !== control.params.choices.allowCollapse) control.container.addClass("allowCollapse");
    },
    /**
   * After control has been first rendered, start re-rendering when setting changes.
   *
   * React is able to be used here instead of the wp.customize.Element abstraction.
   *
   * @returns {void}
   */ ready: function ready() {
        const control = this;
        /**
     * Update component value's state when customizer setting's value is changed.
     */ control.setting.bind((val)=>{
            control.updateComponentState(val);
        });
    },
    /**
   * This method will be overriden by the rendered component.
   */ updateComponentState: (val)=>{},
    /**
   * Handle removal/de-registration of the control.
   *
   * This is essentially the inverse of the Control#embed() method.
   *
   * @link https://core.trac.wordpress.org/ticket/31334
   * @returns {void}
   */ destroy: function destroy() {
        const control = this;
        // Garbage collection: undo mounting that was done in the embed/renderContent method.
        ReactDOM.unmountComponentAtNode(control.container[0]);
        // Call destroy method in parent if it exists (as of #31334).
        if (wp.customize.Control.prototype.destroy) wp.customize.Control.prototype.destroy.call(control);
    }
});
var $a8a3b6d68a8446d2$export$2e2bcd8739ae039 = $a8a3b6d68a8446d2$var$KirkiInputSliderControl;


// Register control type with Customizer.
wp.customize.controlConstructor['kirki-input-slider'] = (0, $a8a3b6d68a8446d2$export$2e2bcd8739ae039);

})();
//# sourceMappingURL=control.js.map
